import React from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const DiveCopyrightAgreement = ({
  photosUploadedAndAgreed,
  setPhotosUploadedAndAgreed,
  currentUser,
}) => {
  const handleCheckboxChange = (event) => {
    setPhotosUploadedAndAgreed(event.target.checked);
  };

  return (
    <Box p={2} border="1px solid lightgrey" borderRadius={1}>
      <FormGroup>
        <Typography gutterBottom>Copyright</Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={photosUploadedAndAgreed}
              onChange={handleCheckboxChange}
              name="photosUploadedAndAgreed"
              required
            />
          }
          label={`I ${
            currentUser
              ? `(${currentUser.displayName}) certify that I took/created these photos myself.`
              : "(Not logged in)"
          }`}
        />
        <Typography variant="caption" color="textSecondary">
          Copyright violations of any kind, including photos from other sources
          (magazines, books, web) will result in your account being disabled
          permanently. If you have explicit written permission from the owner of
          a photo you did not take, you can post it if you include "with
          permission from [source]" in the photo caption.
        </Typography>
      </FormGroup>
    </Box>
  );
};

export default DiveCopyrightAgreement;
